import { Spinner } from "@acme/ui/spinner";
import type { PropsWithChildren } from "react";
import { AuthProvider } from "~/features/auth/_providers/auth.provider.js";
import { authClient } from "~/features/auth/_utils/auth-client.js";

export function AuthSessionGate({ children }: PropsWithChildren)
{
  const { data, isPending } = authClient.useSession();

  if (isPending)
  {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background">
        <Spinner className="size-8 text-muted-foreground" />
      </div>
    );
  }

  return <AuthProvider initialSession={data ?? null}>{children}</AuthProvider>;
}
